import type { ArtifactSupportedFileTypeCapabilitiesApi } from '@ingenico/api-sdk-device-management-private-v2';
import {
  RESOURCE_ARTIFACT_DEFAULT_CAPABILITIES,
  type ResourceArtifactCapabilitiesFront,
} from '../domain/models/resources.model';

// API contract normalization for file extensions used by FileSelect.
export function toResourceFileExtensions(value: ArtifactSupportedFileTypeCapabilitiesApi[]): string[] {
  return value
    .map((item) => item.extension.trim())
    .filter((item) => item.length > 0)
    .map((item) => (item.startsWith('.') ? item.toLowerCase() : `.${item.toLowerCase()}`));
}

function normalizeResourceSizeFromBytes(
  bytes: number,
): Pick<ResourceArtifactCapabilitiesFront, 'maxFileSize' | 'unitFileSize'> {
  if (!Number.isFinite(bytes) || bytes <= 0) {
    return {
      maxFileSize: RESOURCE_ARTIFACT_DEFAULT_CAPABILITIES.maxFileSize,
      unitFileSize: RESOURCE_ARTIFACT_DEFAULT_CAPABILITIES.unitFileSize,
    };
  }

  // FileSelect validates the original byte limit; display formatting is separate.
  return { maxFileSize: bytes, unitFileSize: 'Bytes' };
}

export function parseResourceMaxFileSize(
  supportedFileTypes: ArtifactSupportedFileTypeCapabilitiesApi[],
): Pick<ResourceArtifactCapabilitiesFront, 'maxFileSize' | 'unitFileSize'> {
  // Resource rule: use strictest size across supported extensions.
  const maxFileSizes = supportedFileTypes
    .map((item) => item.maxFileSize)
    .filter((value): value is number => typeof value === 'number' && Number.isFinite(value) && value > 0);

  if (maxFileSizes.length > 0) {
    return normalizeResourceSizeFromBytes(Math.min(...maxFileSizes));
  }

  return {
    maxFileSize: RESOURCE_ARTIFACT_DEFAULT_CAPABILITIES.maxFileSize,
    unitFileSize: RESOURCE_ARTIFACT_DEFAULT_CAPABILITIES.unitFileSize,
  };
}
